// extracted by mini-css-extract-plugin
module.exports = {"alert":"CategoriesEdit_alert__1XN_k"};